module.exports = __webpack_public_path__ + "static/media/parts_06.c84e98ca.svg";